import { useDonationFieldArray } from './useDonationFieldArray';
import { DonationSource, DonationSources, Options } from './EstatePlanningCharitableDonations.meta';

export const mapDonationSourceToOption = ({
  Name,
  Id,
  Type,
  IsSimulatedSource,
  Value,
  SimulatedAccountType,
  EntityId,
}: DonationSource) => ({
  label: Name,
  value: Id,
  type: Type,
  isSimulatedSource: IsSimulatedSource,
  amount: Value,
  simulatedAccountType: SimulatedAccountType,
  entityId: EntityId,
});

const generateDonationSourceOptions = (donationSources: DonationSources | null) => [
  ...(donationSources?.InEstate
    ? [
        {
          label: 'Intra-Estate',
          options: donationSources.InEstate.map(mapDonationSourceToOption),
        },
      ]
    : []),
  ...(donationSources?.OutOfEstate
    ? [
        {
          label: 'Outside of Estate',
          options: donationSources.OutOfEstate.map(mapDonationSourceToOption),
        },
      ]
    : []),
];

interface Params {
  options: Options;
}

export const useEstatePlanningCharitableDonations = ({ options }: Params) => {
  const donationsFieldArray = useDonationFieldArray();

  const primarySourceOptions = generateDonationSourceOptions(options.PrimaryDonationSources);

  const spouseSourceOptions = generateDonationSourceOptions(options.SpouseDonationSources);

  const recipientOptions = options.Recipients.map(({ Name, Id }) => ({
    label: Name,
    value: Id,
  }));

  const donorOptions = options.DonorOptions.map(({ Value, Label }) => ({
    value: Value,
    label: Label,
  }));

  return {
    donationsFieldArray,
    primarySourceOptions,
    spouseSourceOptions,
    recipientOptions,
    donorOptions,
  };
};
